import DemandoriaIcon from "../../../assets/svg/logo-full.svg";
import Link from "@mui/material/Link";
import { Box, SxProps, Typography } from "@mui/material";
import { sharedStyles } from "@/styles/shared";
import { generalWhite } from "@/styles/colors";
import { useTranslation } from "react-i18next";

const footerContainer: SxProps = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  padding: 4,
  color: "text.secondary",
  backgroundColor: "text.primary",
  textAlign: "center",
};

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box sx={footerContainer}>
      <Box sx={{ ...sharedStyles.horizontalContent, gap: 1 }}>
        <img
          src={DemandoriaIcon}
          alt="Demandoria Icon"
          loading="lazy"
          style={{ width: "20px", height: "20px" }}
        />

        <Typography fontWeight="bold" variant="h6" color={generalWhite}>
          Demandoria
        </Typography>
      </Box>

      <Box sx={{ ...sharedStyles.verticalContent, gap: 1 }}>
        <Typography variant="body2">
          {t("components.footer.copyright", { year: new Date().getFullYear() })}
        </Typography>

        <Typography variant="body2">
          {t("components.footer.contact")}{" "}
          <Link
            href="mailto:demandoria@gmail.com"
            color="secondary.main"
            underline="none"
            sx={{ fontWeight: "bold" }}
          >
            demandoria@gmail.com
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
